import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'
import { PaymentType } from '../../enums/payment-type.enum'
import { AccountType } from '../../enums/account-type.enum'

// the name this account goes by in a bank statement export, used to map CSV rows onto it during an
// import. an empty field is stored as null so "cleared" and "never set" are the same state.
export const importAliasSchema = z
  .string()
  .trim()
  .max(100, 'Import name must be at most 100 characters')
  .transform((v) => (v === '' ? null : v))
  .nullish()

export const createAccountSchema = z
  .object({
    name: z.string().min(2, 'Name must be at least 2 characters').max(100),
    importAlias: importAliasSchema,
    paymentType: z.nativeEnum(PaymentType),
    currency: z.nativeEnum(Currency),
    type: z.nativeEnum(AccountType).optional(),
    balance: z.number().optional().default(0),
    default: z.boolean().optional().default(false),
    archived: z.boolean().optional().default(false),
    creditLimit: z.number().positive('Credit limit must be greater than 0').optional(),
    closingDay: z.number().int().min(1).max(31).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.type === AccountType.CREDIT) {
      if (data.paymentType !== PaymentType.CARD) {
        ctx.addIssue({
          code: 'custom',
          path: ['paymentType'],
          message: 'Credit accounts must use CARD payment type',
        })
      }
      if (data.creditLimit === undefined) {
        ctx.addIssue({
          code: 'custom',
          path: ['creditLimit'],
          message: 'Credit limit is required for credit accounts',
        })
      }
      if (data.closingDay === undefined) {
        ctx.addIssue({
          code: 'custom',
          path: ['closingDay'],
          message: 'Closing day is required for credit accounts',
        })
      }
    }
  })

export type CreateAccountDto = z.infer<typeof createAccountSchema>
